import React, { useReducer } from "react";
import useSWR, { mutate } from "swr";
import BottomButton from "../components/BottomButton";
import RecentReviewsJsonLDWrapper from "../components/RecentReviewsJsonLDWrapper";
import ReviewList from "../components/ReviewList";
import { AppContext, defaultAppState, reducer } from "../containers/All";

const fetcher = (...args) => fetch(...args).then((r) => r.json());

export const prefetchMerchantData = (merchantId) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${merchantId}.json?widget=recent`;
  return mutate(url, fetcher(url), false);
};

const RecentReviews = (props) => {
  const [state, dispatch] = useReducer(reducer, { ...defaultAppState, page: 1 });
  const url = `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${props.merchant}.json?widget=recent`;

  const { data } = useSWR(
    url,
    fetcher,
    { revalidateOnFocus: false }
  );

  if (!data || !data.merchant) {
    return null;
  }

  const { merchant } = data;
  const { truncateDest, lines, num } = props;

  return (
    <AppContext.Provider value={{ state, dispatch, settings: { ...props } }}>
      <RecentReviewsJsonLDWrapper merchant={merchant} reviews={state.reviews} />
      <div id="reviews">
        <ReviewList
          merchant={merchant}
          hidePlatform={true}
          truncateDest={truncateDest}
          truncateText={true}
          truncateAt={lines}
          state={merchant.state}
          hideResponses={true}
          page={state.page}
          limit={num}
          expandInline={false}
          randomize={props.randomize}
          thirdParty={props.thirdParty}
          skipPagination={true}
          currentLocationReviewsOnly={props.currentLocationReviewsOnly}
        />
        <BottomButton merchant={merchant} writeDisable={props.writeDisable} truncateDest={truncateDest} />
      </div>
    </AppContext.Provider>
  );
};

export default RecentReviews;



// WEBPACK FOOTER //
// ./src/containers/RecentReviews.jsx